import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApplicationBidInput, IApplicationBid } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ApplicationBidApiService {
  abstract update(applicationBid: IApplicationBidInput): Observable<any>;
  abstract delete(applicationBid: IApplicationBidInput): Observable<any>;
  abstract getApplicationBidList(applicationId: string): Observable<IApplicationBid[]>;
}
